import { Link } from "react-router-dom";
import "./Landing.css";

export default function Sartlar() {
  return (
    <div className="lx-root">
      <main className="lx-legal" data-testid="page-sartlar">
        <h1>Kullanım Şartları</h1>
        <p className="lx-meta">Son güncelleme: 11 Şubat 2026</p>

        <h2>1. Hizmetin Tanımı</h2>
        <p>
          Terminal-EX (“Platform”), davetli kullanıcıların kripto borsalarında
          (Darkex, Binance vb.) hedge arbitraj pozisyonları açmasına ve
          yönetmesine yardımcı olan bir araçtır. Platform yalnızca araç
          niteliğindedir; piyasa katılımcısı veya yatırım danışmanı değildir.
        </p>

        <h2>2. Üyelik</h2>
        <ul>
          <li>Üyelik davetlidir. Talepler admin (@paranoya) tarafından
              değerlendirilir.</li>
          <li>Her kullanıcı yalnızca kendi Telegram hesabıyla giriş yapar.</li>
          <li>Hesap paylaşımı, devri veya başkası adına kullanımı yasaktır.</li>
        </ul>

        <h2>3. Risk Uyarısı</h2>
        <p>
          Kripto vadeli işlem piyasaları yüksek volatilite içerir.
          Pozisyonlar kısa sürede tüm teminatı kaybedebilir. Platform tarafından
          üretilen sinyaller, AI çıktıları, simülasyonlar ve grafikler
          <strong> yatırım tavsiyesi değildir</strong>. Tüm risk kullanıcıya
          aittir.
        </p>

        <h2>4. API Anahtarları</h2>
        <p>
          Kullanıcılar borsa API anahtarlarını yalnızca <em>Read</em>, <em>Trade</em>
          ve <em>Futures</em> izinleriyle vermelidir. <strong>Withdraw / Transfer
          yetkisi açıkça yasaktır</strong>; bu yetkiyi içeren anahtarlar
          istenildiği anda silinebilir. Anahtarlar sunucuda şifrelenerek
          saklanır; üçüncü kişilere aktarılmaz.
        </p>

        <h2>5. Yasaklı Kullanım</h2>
        <ul>
          <li>Sahte hesaplarla birden fazla kayıt oluşturmak</li>
          <li>API’ye otomatik kötüye kullanım (rate-limit ihlali, DoS)</li>
          <li>Platformun teknik altyapısını tersine mühendislikle çözmek</li>
          <li>Yasadışı amaçlı işlemler veya kara para aklama girişimleri</li>
        </ul>

        <h2>6. Hesap Askıya Alma</h2>
        <p>
          Platform; şüpheli aktivite, yasak kullanım veya hizmetin kötüye
          kullanılması durumunda hesabı önceden bildirimde bulunmaksızın
          askıya alma veya kalıcı olarak kapatma hakkını saklı tutar.
        </p>

        <h2>7. Sorumluluk Reddi</h2>
        <p>
          Platform “olduğu gibi” sunulur. Borsa API’sinden kaynaklanan
          gecikme, hata veya kayıplar için Platform sorumlu tutulamaz.
          Yasal sınırlar dahilinde, sorumluluk son 30 günlük üyelik
          ücretiyle sınırlıdır (ücret yoksa sıfırdır).
        </p>

        <h2>8. Değişiklikler</h2>
        <p>
          Bu şartlar zaman zaman güncellenebilir. Güncellemeler bu sayfadan
          yayımlanır; üyelik devam ederse güncellenmiş şartlar kabul edilmiş
          sayılır.
        </p>

        <h2>9. İletişim</h2>
        <p>Telegram: <strong>@paranoya</strong></p>

        <Link to="/" className="lx-back" data-testid="sartlar-back">← Geri dön</Link>
      </main>
    </div>
  );
}
